// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  date1comesAfterdate2,
  validDateValue,
  valueMustBeWithinMaxLength,
} from 'validators/common'

const validateAdminFields = (v, error) => {
  // if we're hiding the admin fields, don't perform validation on these fields
  if (v.hideAdminFields) {
    return
  }

  // rcnNumber can either be undefined (on Bulk Edits)
  // or if it's an empty string, no need to validate.
  if (v.rcnNumber) {
    error.rcnNumber = valueMustBeWithinMaxLength(v.rcnNumber, 8)
  }

  // jobCode can either be undefined (on Bulk Edits)
  // or if it's an empty string, no need to validate.
  if (v.jobCode) {
    error.jobCode = valueMustBeWithinMaxLength(v.jobCode, 25)
  }

  v.administration.forEach((d, i) => {
    const err = {}

    err.ulsFileNumber = valueMustBeWithinMaxLength(d.ulsFileNumber, 14)
    err.publicNoticeDate = validDateValue(d.publicNoticeDate)
    err.licenseDate = validDateValue(d.licenseDate)
    err.expirationDate = validDateValue(d.expirationDate)

    error.administration.push(err)
  })
}

export default validateAdminFields
